// App.js
import React, { useState, useEffect } from "react";
import "./App.css";
import Modal from "./Modal";
import AvatarSelectionModal from "./components/AvatarSelectionModal";
import stageContent from "./stagesContent";
import "./index.css";

const App = () => {
  const [currentStage, setCurrentStage] = useState(1);
  const [animate, setAnimate] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showAvatarModal, setShowAvatarModal] = useState(false); // State for avatar modal
  const [selectedAvatar, setSelectedAvatar] = useState(
    `${process.env.PUBLIC_URL}/profile.jpg`
  ); // State for selected avatar with default image

  useEffect(() => {
    setAnimate(true);
    const timer = setTimeout(() => setAnimate(false), 1000);
    return () => clearTimeout(timer);
  }, [currentStage]);

  const handleNextStage = () => {
    setCurrentStage((prevStage) =>
      prevStage < Object.keys(stageContent).length ? prevStage + 1 : prevStage
    );
  };

  const handlePrevStage = () => {
    setCurrentStage((prevStage) => (prevStage > 0 ? prevStage - 1 : prevStage));
  };

  const handleStageClick = (stage) => {
    setCurrentStage(stage);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  // Method to open the avatar selection modal
  const selectAvatar = () => {
    setShowAvatarModal(true);
  };

  // Method to close the avatar selection modal
  const closeAvatarModal = () => {
    setShowAvatarModal(false);
  };

  return (
    <div className="App">
      <header className="App-header" >
        <h1><b>Raregivers Interactive Journey Map</b></h1>
        {!showModal && (
          <button className="avatar-button" onClick={selectAvatar}>
            <img
              src={selectedAvatar}
              alt="Selected Avatar"
              className="selected-avatar"
            />
          </button>
        )}

        <div className="journey-map-container">
          <img
            src={`${process.env.PUBLIC_URL}/journey-map.png`}
            alt="Journey Map"
          />
          <div
            className="clickable-area stage0"
            onClick={() => handleStageClick(0)}
          ></div>
          <div
            className="clickable-area stage1"
            onClick={() => handleStageClick(1)}
          ></div>
          <div
            className="clickable-area stage2"
            onClick={() => handleStageClick(2)}
          ></div>
          <div
            className="clickable-area stage3"
            onClick={() => handleStageClick(3)}
          ></div>
          <div
            className="clickable-area stage4"
            onClick={() => handleStageClick(4)}
          ></div>
          <div
            className="clickable-area stage5"
            onClick={() => handleStageClick(5)}
          ></div>
          <div
            className="clickable-area stage6"
            onClick={() => handleStageClick(6)}
          ></div>
          <div
            className="clickable-area stage7"
            onClick={() => handleStageClick(7)}
          ></div>
        </div>
      </header>

      <Modal
        show={showModal}
        onClose={closeModal}
        title={stageContent[currentStage].title}
        content={stageContent[currentStage].content}
        avatar={selectedAvatar}
        image={stageContent[currentStage].image}
        videoSrc={stageContent[currentStage].videoSrc}
        isFullScreen={true} // Set to true to make the image fullscreen
        onNext={handleNextStage}
        onPrev={handlePrevStage}
        currentStage={currentStage}
      />
      <AvatarSelectionModal
        show={showAvatarModal}
        onClose={closeAvatarModal}
        onSelectAvatar={(avatar) => {
          // Handle avatar selection
          setSelectedAvatar(avatar);
          closeAvatarModal();
        }}
      />
    </div>
  );
};

export default App;
